const _ = require('underscore');
const React = require("react");
const createReactClass = require("create-react-class");

const UploadCertificateForm = require('./UploadCertificateForm.jsx');
const LetsEncrypt = require('./LetsEncrypt.jsx');

const SSLComponent = createReactClass({
	getInitialState: function() {
		let model = this.props.model;
		model.SecurityID = this.props.model.InitialSecurityID;
		delete(model.InitialSecurityID);

		let initialMessage = { type: 'success', body: '' };
		if (model.Error) {
			initialMessage = { type: 'error', body: model.Error };
		}
		if (model.Message) {
			initialMessage = { type: 'success', body: model.Message };
		}

		let timer = null;
		if (model.CurrentCertificate && this.shouldRefresh(model.CurrentCertificate)) {
			timer = setInterval(this.refresh, 10000);
		}

		return {
			message: initialMessage,
			model: this.props.model,
			timer: timer,
			type: this.props.model.HasPendingLetsEncryptDomains ? "LE" : null,
		};
	},

	updateData: function(data) {
		data.SecurityID = data.NewSecurityID;
		delete(data.NewSecurityID);

		let initialMessage = { type: 'success', body: '' };
		if (data.Error) {
			initialMessage = { type: 'error', body: data.Error };
		}
		if (data.Message) {
			initialMessage = { type: 'success', body: data.Message };
		}

		let timer = this.state.time;
		if (timer === null && this.state.model.CurrentCertificate && this.shouldRefresh(this.state.model.CurrentCertificate)) {
			timer = setInterval(this.refresh, 10000);
		}

		this.setState({
			message: initialMessage,
			model: data,
			timer: timer
		});
	},

	toggleView: function(event) {
		this.setState({
			type: event.currentTarget.dataset.type,
			message: { type: 'success', body: '' }
		});
	},

	cancelHandler: function() {
		this.setState({
			type: null,
			message: { type: 'success', body: '' }
		});
	},

	shouldRefresh: function(cert) {
		return ['Active', 'Failed', 'Pending deployment'].indexOf(cert.Status) === -1;
	},

	refresh: function() {
		if (this.state.model.CurrentCertificate && !this.shouldRefresh(this.state.model.CurrentCertificate)) {
			clearInterval(this.state.timer);
			return;
		}

		var self = this;
		return Q($.ajax({
			type: "GET",
			url: window.location + '/refresh',
			contentType: 'json'
		}))
			.then(function(data) {
				self.updateData(data)
			})
			.fail(function() {
				self.setState({
					message: { type: 'danger', body: "Failed to refresh your SSL certificate. Please reload the page and try again." }
				});
			});
	},

	render: function() {
		let message = null;
		if (this.state.message.body) {
			message = <Message type={this.state.message.type} message={this.state.message.body} />
		}

		let leButton = null;
		if (this.state.model.LetsEncryptEnabled) {
			leButton = (
				<button type="button" data-type="LE" className="btn btn-primary" onClick={this.toggleView}>Configure Let's Encrypt</button>
			)
		}


		let view = (
			<div className="btn-toolbar">
				{leButton}
				<button type="button" data-type="Custom" className="btn btn-default" onClick={this.toggleView}>Configure custom certificate</button>
			</div>
		);

		switch (this.state.type) {
			case "LE":
				view = (
					<div className="replace-ssl">
						<h4>Configure Let's Encrypt</h4>
						<LetsEncrypt
							model={this.state.model}
							afterSuccess={this.updateData}
							cancelHandler={this.cancelHandler}
						/>
					</div>
				);
				break;

			case "Custom":
				view = (
					<div className="replace-ssl">
						<h4>Configure custom certificate</h4>
						<UploadCertificateForm
							model={this.state.model}
							actionURL={this.state.model.UploadCertificateActionURL}
							afterSuccess={this.updateData}
							cancelHandler={this.cancelHandler}
						/>
					</div>
				);
				break;
		}

		return (
			<div>
				<CertList
					model={this.state.model}
				/>
				{message}
				{view}
			</div>
		);
	}
});

const Message = createReactClass({
	render: function() {
		return (
			<div
				className={'alert alert-' + this.props.type}
				dangerouslySetInnerHTML={{__html:this.props.message}}
			/>
		);
	}

});

const CertList = createReactClass({
	render: function() {
		return (
			<div className="certificates table-responsive">
				<table className="table table-fullwidth">
					<thead>
					<tr>
						<th></th>
						<th>Domain(s)</th>
						<th>Expires</th>
						<th>Issuer</th>
						<th>Added</th>
						<th>Status</th>
					</tr>
					</thead>
					<tbody>
					<Cert cert={this.props.model.CurrentCertificate} />
					</tbody>
				</table>
			</div>
		);
	}
});

const Cert = createReactClass({
	render: function() {
		if (!this.props.cert) {
			return (
				<tr className="active">
					<td><img className="cert-image" src="/themes/platform/img/certificate.png" alt="Certificate" /></td>
					<td>Default certificate</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td className="status">Active</td>
				</tr>
			);
		}

		let domains = [];
		_.map(this.props.cert.Domains, function(domain) {
			domains.push(<li key={domain}>{domain}</li>);
		});

		let icon = null;
		if (this.props.cert.Status !== 'Active' && this.props.cert.Status !== 'Failed') {
			icon = (
				<i className="fa fa-refresh fa-spin fa-fw" aria-hidden="true"></i>
			);
		}

		return (
			<tr className={this.props.cert.Status.toLowerCase()}>
				<td><img className="cert-image" src="/themes/platform/img/certificate.png" alt="Certificate" /></td>
				<td className="domains"><ul>{domains}</ul></td>
				<td>{this.props.cert.ExpiryDate}</td>
				<td>{this.props.cert.Issuer}</td>
				<td>{this.props.cert.LastEdited} by {this.props.cert.UploaderName}</td>
				<td className="status">{icon} {this.props.cert.Status}</td>
			</tr>
		);
	}
});

module.exports = SSLComponent;
